export default "__VITE_ASSET__800573fe__"